// Pedir un trozo de la aplicación ANTES de que haga falta.
//
// POR QUE EXISTE. Las páginas van en `lazy()`, así que el trozo de `CursoDetail` no se
// descarga hasta que alguien pulsa. Entre la pulsación y la primera pintada hay una ida y
// vuelta a la red entera, y mientras tanto lo que se ve es el `fallback` del `Suspense`:
// una pantalla en blanco. Medido el 16 de septiembre de 2026 abriendo Creatividad desde la
// portada: **cuatro segundos en blanco**, y la sensación que deja no es «está cargando»,
// es «aquí no hay cursos».
//
// LO QUE SE HACE. Se pide el trozo en cuanto hay una PISTA de que va a hacer falta —el
// ratón encima del enlace, el tabulador encima del enlace— y, si nadie toca nada, cuando el
// navegador esté ocioso. Cuando llega la pulsación el trozo ya está en la caché de módulos
// y la página se pinta en el mismo cuadro: no hay `fallback` que enseñar.
//
// POR QUE NO ES GRATUITO Y AUN ASI COMPENSA. Esto se estudia en el Chromebook del instituto,
// con la wifi del centro; un trozo de más descargado en vano son unas decenas de kilobytes,
// y el que se descarga a tiempo son cuatro segundos de pantalla blanca que no pasan. Por eso
// se adelanta SOLO lo que está a un clic de la pantalla que se está mirando, nunca la
// aplicación entera.
//
// EL `Set` NO ES UNA CACHÉ. La caché es del navegador y de webpack; esto solo evita llamar
// mil veces a `import()` mientras el ratón pasea por encima de cinco píldoras seguidas.

const pedidos = new Set();

/**
 * Pide un trozo una sola vez. `traer` es la función que hace el `import()` dinámico; tiene
 * que ser LA MISMA expresión literal que usa el `lazy()` de la ruta, porque es la expresión
 * —y no el módulo— lo que webpack usa para decidir qué trozo es cuál.
 */
export function adelanta(nombre, traer) {
  if (pedidos.has(nombre)) return;
  pedidos.add(nombre);
  Promise.resolve()
    .then(traer)
    .catch(() => pedidos.delete(nombre));  // si falló, que se pueda reintentar
}

/**
 * Lo mismo, pero esperando a que el navegador no tenga nada mejor que hacer. Para lo que se
 * va a necesitar «seguro, pero no ahora»: adelantarlo durante la primera pintada le quitaría
 * red justo a lo que se está mirando.
 */
export function adelantaSinPrisa(nombre, traer, espera = 2000) {
  const luego = () => adelanta(nombre, traer);
  if (typeof window === "undefined") return;
  if (typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(luego, { timeout: espera });
  } else {
    window.setTimeout(luego, espera);
  }
}

/** Los tres manejadores que hay que colgar de un enlace para adelantar su destino. */
export function pistasDe(nombre, traer) {
  const tira = () => adelanta(nombre, traer);
  return { onMouseEnter: tira, onFocus: tira, onTouchStart: tira };
}
